// src/components/Layout/Header.js
import React from 'react';
import { Link } from 'react-router-dom';
import { FaXTwitter } from 'react-icons/fa6'; // Import the X icon
import './Header.css';

const Header = () => {
  return (
    <header className="app-header">
      <div className="container header-content">
        <Link to="/" className="logo">DiscoverSupps</Link>
        
        {/* Nav now contains the About link and X icon */}
        <nav className="main-nav">
          <Link to="/about">About</Link>
          <a
            href="https://x.com/DiscoverSupps"
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon-link"
            aria-label="Visit our X profile"
          >
            <FaXTwitter />
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Header;
